import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMapPins } from "@tabler/icons-react";
import { SubAreasDef } from "./SubAreasDef";

export const SubAreasIcon = IconMapPins;
export const SubAreasHelpText = '* Sub áreas para ruteo.';

export class SubAreas extends Entity<SubAreasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new SubAreasDef(), parentKeys);
        this.Form = import('./SubAreasForm').then((module) => module.SubAreasForm);
        this.Title = "Sub Areas";
        this.HelpText = SubAreasHelpText;
        this.Icon = SubAreasIcon;
    }
}